module.exports = __webpack_public_path__ + "static/media/elon_musk.3c907e44.jpg";